export enum RSVPLayout {
  THREE_SMILIES = 'THREE_SMILIES',
  ONE_BUTTON = 'ONE_BUTTON',
  TWO_BUTTONS = 'TWO_BUTTONS',
}
export namespace RSVPLayout {
  export function getAllRsvpLayouts(): RSVPLayout[] {
    return [
      RSVPLayout.TWO_BUTTONS,
      RSVPLayout.THREE_SMILIES,
      RSVPLayout.ONE_BUTTON,
    ];
  }

  export function getDisplayName(layout?: RSVPLayout): string {
    switch (layout) {
      case RSVPLayout.THREE_SMILIES:
        return 'APP.RSVP_LAYOUT.THREE_SMILIES';
      case RSVPLayout.ONE_BUTTON:
        return 'APP.RSVP_LAYOUT.ONE_BUTTON';
      case RSVPLayout.TWO_BUTTONS:
        return 'APP.RSVP_LAYOUT.TWO_BUTTONS';
      default:
        return '';
    }
  }
}
